module.exports = __webpack_public_path__ + "img/curacao.6e3317d9.svg";